<template>
    <div class="versions-handler width-100%">
        <div v-if="versions.length">
            <div
                v-for="(version, i) in versions"
                :key="i"
                :class="{
                    'm-top--s': i > 0,
                }"
            >
                <ds-version-card
                    :version="version"
                    :is-expanded="i === 0"
                    :set-selected-offer="setSelectedOffer"
                    :selected-offer="selectedOffer"
                    @click-select-version="versionId => onSelectVersion(versionId)"
                    @click-open-wizard-form-modal="onOpenWizardFormModal"
                />
            </div>
        </div>
        <div v-else class="versions-handler__no-result p-left--s p-right--s m-top--l ts-align--center">
            <h4 class="versions-handler__no-result-title ts--body color--grey-900 ts-weight--700 m-bottom--xxs">
                {{ $t('multi-section-version.no-results-available') }}
            </h4>
            <h6 class="versions-handler__no-result-subtitle ts--body-small color--grey-900">
                {{ $t('multi-section-version.remove-filters-to-see-matches') }}
            </h6>
        </div>
    </div>
</template>
<script>
import DsVersionCard from '@v4/common/components/molecules/DsVersionCard.vue';

/**
 * A component to handle the versions list
 *
 * @version 4.0.0
 * @example ./examples/VersionsHandler.md
 */
export default {
    name: 'VersionsHandler',
    components: {
        DsVersionCard,
    },
    props: {
        /**
         * Vehicle versions info object.
         */
        versions: {
            type: Array,
            default: () => [],
        },
        /**
         * Selected offer item object.
         */
        selectedOffer: {
            type: Object,
            default: () => ({}),
        },
        /**
         * Set version item as selected.
         */
        setSelectedOffer: {
            type: Function,
            default: () => {},
        },
    },
    methods: {
        onSelectVersion(versionId) {
            this.$emit('click-select-version', versionId);
        },
        onOpenWizardFormModal(version) {
            this.$emit('click-open-wizard-form-modal', version);
        },
    },
};
</script>
